import { render, staticRenderFns } from "./CreateSpecimen.vue?vue&type=template&id=55bf8d7a"
import script from "./CreateSpecimen.vue?vue&type=script&lang=js"
export * from "./CreateSpecimen.vue?vue&type=script&lang=js"
import style0 from "./CreateSpecimen.vue?vue&type=style&index=0&id=55bf8d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports